var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSpeechBubble18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 15c-.873 0-2.204.446-3.992 1.338a1 1 0 0 1-1.321-1.38l.174-.313.91-1.25C1.925 12.132 1 10.5 1 8.5 1 4.91 4.582 2 9 2s8 2.91 8 6.5S13.5 15 8 15zm1-2c3.314 0 6-2.015 6-4.5S12.314 4 9 4 3 6.015 3 8.5 5.686 13 9 13z",
    clipRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTggMTVjLS44NzMgMC0yLjIwNC40NDYtMy45OTIgMS4zMzhhMSAxIDAgMCAxLTEuMzIxLTEuMzhsLjE3NC0uMzEzLjkxLTEuMjVDMS45MjUgMTIuMTMyIDEgMTAuNSAxIDguNSAxIDQuOTEgNC41ODIgMiA5IDJzOCAyLjkxIDggNi41UzEzLjUgMTUgOCAxNXptMS0yYzMuMzE0IDAgNi0yLjAxNSA2LTQuNVMxMi4zMTQgNCA5IDQgMyA2LjAxNSAzIDguNSA1LjY4NiAxMyA5IDEzeiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+";
export { SvgSpeechBubble18 as ReactComponent };